module.exports = __webpack_public_path__ + "templates.dialog.welcome-member-referral-credits-94ecce6e.html";